// Where to send somebody to install the apps.
//
// One place, because a store link guessed at the call site is a link
// nobody checks. The Play URL is derived from the package name in
// `public/.well-known/assetlinks.json`; the App Store id is the one Apple
// issued on submission.
//
// Both are live as of 2026-09-02. `APP_STORE_URL` keeps its `| null` type
// on purpose — the landing page renders the iPhone badge only when it is
// set, so an unpublished store degrades to one badge rather than a link
// that 404s. A test asserts neither ever ships empty or with a placeholder
// still in it.

export const ANDROID_PACKAGE = 'com.toposds.production';

export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;

export const APP_STORE_ID = '6759071297';

export const APP_STORE_URL: string | null = `https://apps.apple.com/us/app/toposds/id${APP_STORE_ID}`;
